import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@wix/design-system';
import s from '../PlansGrid.scss';

interface NonPurchasableProps {
  isLoggedIn: boolean;
  isUpgrade: boolean;
}

export const NonPurchasable: React.FC<NonPurchasableProps> = ({
  isUpgrade,
}) => {
  const { t } = useTranslation();

  const getNonPurcashableKey = () => {
    if (isUpgrade) {
      return 'plans_page.dayful_2nd_upgrade';
    }
    return '';
  };

  return (
    <Text className={s.nonPurchasableMessage} size='tiny'>
      {t(getNonPurcashableKey())}
    </Text>
  );
};
